import React, { useEffect, useState } from "react";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Navigation from "../Navigation/Navigation";
import "../Explore/Explore.css";
import { FaLocationArrow } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { MdKeyboardArrowDown } from "react-icons/md";
import ExploreSlider from "../ExploreSlider/ExploreSlider";
import ExploreCategories from "../ExploreCategories/ExploreCategories";
import LatestLocals from "../LatestLocals/LatestLocals";
import PopularDeals from "../PopularDeals/PopularDeals";
import { exploreApi } from "../../Utils/Api/Explore";
import { CountryList } from "../../Utils/Api/CountryList";
import { CategoryList } from "../../Utils/Api/CategoryList";
import { OtherDealsApi } from "../../Utils/Api/OtherDealsApi";
import Loader from "../../Components/Loader/Loader";
import { useNavigate } from "react-router-dom";

const Explore = () => {
  const [exploreVoucherList, setExploreVoucherList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [popularDealsList, setPopularDealsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const ExploreHandler = async () => {
    const data = {
      voucherId: 1,
      city_id: 1,
    };
    setLoading(true);
    const exploreData = await exploreApi(() => {
      navigate("/");
    });
    const CountryListData = await CountryList(() => {
      navigate("/");
    });
    const CatogryListData = await CategoryList(() => {
      navigate("/");
    });
    const populardealsdata = await OtherDealsApi(data, () => {
      navigate("/");
    });
    setLoading(false);
    setExploreVoucherList(exploreData.voucher_list);
    setCountryList(CountryListData.res);
    setCategoryList(CatogryListData.res);
    setPopularDealsList(populardealsdata.res);
  };

  useEffect(() => {
    ExploreHandler();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-3 pr-3 pb-4">
          <div className="text-center d-flex justify-content-center mb-3 mt-3 explore-deal">
            <p className="exploretext">Explore Deals in</p>
            <FaLocationArrow className="arrowloacation" />
            <Form.Select
              aria-label="Default select example"
              className="location-select"
            >
              <option>Select Location</option>
              {countryList.length !== 0 ? (
                countryList.map((country) => {
                  return (
                    <>
                      <option value={country[0]}>{country[1]}</option>
                    </>
                  );
                })
              ) : (
                <option value="">None</option>
              )}
            </Form.Select>
          </div>
          <ExploreSlider />
          <div className="mt-4 pt-2">
            <div className="category-list">
              <ExploreCategories list={categoryList} />
            </div>
            <div className="latest-local px-3">
              <LatestLocals voucherList={exploreVoucherList} />
            </div>
            <div className="popular-deals px-3 mb-4">
              <PopularDeals popularDealsList={popularDealsList} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Explore;
